import { LoadableRoute } from 'routes/utils/loadable';

export const VizzlyReportingContainer = LoadableRoute({
  loader: () =>
    import(/* webpackChunkName: "VizzlyReporting" */ './VizzlyReporting'),
});
